(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
    $(function(){
        $('.faq-qanda__one__title').click(function(){
            $(this).next('.faq-qanda__one__content').slideToggle();
            $(this).toggleClass('open');
            /* $('.faq-qanda__one__title').not($(this)).next('.faq-qanda__one__content').slideUp();
            $('.faq-qanda__one__title').not($(this)).removeClass('open'); */
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-lookbook"] && !Shopify.designMode) return;
  try {
    
    $(function () {
        $('.js-look-book-open').click(function () {
            var id = $(this).data('id');
            $('#look-book__overlay, .look-book__modal[data-id="look-book__modal' + id + '"]').fadeIn();
            $("body").addClass("look-book-no-scroll");
        });
        
        $('.js-look-book-close , #look-book__overlay').click(function () {
            $('#look-book__overlay, .look-book__modal').fadeOut();
            $("body").removeClass("look-book-no-scroll");
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-links"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    $('.shoplink-title').click(function () {
      $(this).next('.shoplink-content').slideToggle();
      $(this).children('.shoplink-title__inner').toggleClass('border-none');
      $(this).toggleClass('open');
      $('.shoplink-title').not($(this)).next('.shoplink-content').slideUp();
      $('.shoplink-title').not($(this)).removeClass('open');
      $('.shoplink-title').not($(this)).removeClass('border-none');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
